export default __webpack_public_path__ + "static/media/search_girl_warning.27e9fd2a.svg";